import DefaultDataGraphSetting from "./DefaultDataGraphSettings.js";
import Serializable from "../../../../../Serialization/Serializable.js";

export default class CryptoCurrencyViewSettings extends Serializable {
  onSeralisedInfoRecieved(info) {
    this.SummaryBlockSettings = info.SummaryBlockSettings ? info.SummaryBlockSettings : DefaultDataGraphSetting.getDefaultIsSummaryBlockOpen();
    this.ScaleLabelSettings = info.ScaleLabelSettings ? info.ScaleLabelSettings : DefaultDataGraphSetting.getScaleLabelSettings(true);
    this.EarningLineSetting = info.EarningLineSetting ? info.EarningLineSetting : DefaultDataGraphSetting.getEstimateSettings();
    this.HiLoPriceSettings = info.HiLoPriceSettings ? info.HiLoPriceSettings : DefaultDataGraphSetting.getHiLoPriceSetting(true);
    this.HiLoPctSettings = info.HiLoPctSettings ? info.HiLoPctSettings : DefaultDataGraphSetting.getHiLoPctSetting(true);
    this.MASettings = info.MASettings ? info.MASettings : DefaultDataGraphSetting.getMovingAverageSetting();
    // this.CorporateEventsSettings = info.CorporateEventsSettings ? info.CorporateEventsSettings : DefaultDataGraphSetting.getCorporateEventsSetting(false);
    this.OffHighTag = info.OffHighTag ? info.OffHighTag : "OH";
    this.EPSLabelSettings = info.EPSLabelSettings ? info.EPSLabelSettings : DefaultDataGraphSetting.getEPSLabelSettings();
    this.ExternalDataSettings =  info.ExternalDataSettings ? info.ExternalDataSettings : DefaultDataGraphSetting.getExternalDataSettings();
    this.ExternalDataRiPanelSettings = info.ExternalDataRiPanelSettings ? info.ExternalDataRiPanelSettings : DefaultDataGraphSetting.getExternalDataRiPanelSettings();
    this.EDMultiplierSettings = info.EDMultiplierSettings ? info.EDMultiplierSettings : DefaultDataGraphSetting.getMultiplierSetting(false);
    this.TiMenuSettings = info.TiMenuSettings ? info.TiMenuSettings : DefaultDataGraphSetting.getTiMenuSettings();
  }

  getDataObject() {
    return {
      SummaryBlockSettings: this.SummaryBlockSettings,
      EarningLineSetting: this.EarningLineSetting,
      ScaleLabelSettings: this.ScaleLabelSettings,
      HiLoPriceSettings: this.HiLoPriceSettings,
      HiLoPctSettings: this.HiLoPctSettings,
      MASettings: this.MASettings,
      EPSLabelSettings: this.EPSLabelSettings,
      // CorporateEventsSettings: this.CorporateEventsSettings,
      OffHighTag: this.OffHighTag,
      ExternalDataSettings: this.ExternalDataSettings,
      ExternalDataRiPanelSettings: this.ExternalDataRiPanelSettings,
      TiMenuSettings: this.TiMenuSettings
    };
  }

  getObjectMapKey() {
    return "CryptoCurrencyViewSettings";
  }
  getMovingAverageSettingObject(ma, maType, isVisible, lineColor, lineThickness) {
    return DefaultDataGraphSetting.getMovingAverageSettingObject(ma, maType, isVisible, lineColor, lineThickness);
  }
  getDefaultDataGraphSetting() {
    return DefaultDataGraphSetting.getCorporateEventsSetting(true);
  }
}